import { PieChart as ReactPieChart } from 'react-minimal-pie-chart';
import { Link } from 'react-router-dom';

type Slice = {
    color: string;
    percent: number;
    title: string;
    count: number;
    legend: string;
    href?: string;
};

type PieChartProps = {
    title: string;
    figure: number;
    slices: Slice[];
};

function PieChart({ title, figure, slices }: PieChartProps): JSX.Element {
    return (
        <div>
            <p className="font-medium text-gray-900 mb-4">{title}</p>
            <div className="flex items-start gap-4">
                <div className="h-[85px] w-[85px]">
                    <ReactPieChart
                        animate
                        lineWidth={20}
                        startAngle={270}
                        labelPosition={0}
                        data={slices.map((slice) => {
                            return { color: slice.color, value: slice.percent, title: slice.title };
                        })}
                        label={(): string => `${figure}%`}
                        labelStyle={{ fill: '#111827', fontSize: '1.25rem', lineHeight: '1.75rem' }}
                    />
                </div>

                <div>
                    {slices.map((slice) => {
                        return (
                            <div key={slice.title}>
                                <span className={`inline-block w-2 h-2 rounded-full`} style={{ backgroundColor: slice.color }}></span>

                                {slice.href ? (
                                    <Link to={slice.href} className="ml-1 text-sm text-gray-900 hover:underline">
                                        {slice.legend}
                                    </Link>
                                ) : (
                                    <label className={`ml-1 text-sm text-gray-900 `}>{slice.legend}</label>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
export default PieChart;
